import importer from "common/importer";
const { deloitReq: req } = importer("APIs", null);
const Config = importer("Config");

let CORE_SCHEDULER_BASIC_AUTH;
if (Config.PLATFORM_TYPE != "mobile") {
  CORE_SCHEDULER_BASIC_AUTH = WEB_SCHEDULER_BASIC_AUTH;
}

/**
 * @param {String} pdn
 */

export const getLoyaltyDetails = (pdn, authToken) => {
  return req.get("/loyalty/details", {
    headers: {
      Authorization: authToken
    },
    params: {
      pdn
    }
  });
};

export const getLoyaltyContants = () => {
  return req.get("/config", {
    headers: {
      Authorization: `Basic ${Config.SCHEDULER_BASIC_AUTH || CORE_SCHEDULER_BASIC_AUTH}`
    }
  });
};

export const getLoyaltyActivity = (pdn, authToken) => {
  return req.get("/loyalty/history", {
    headers: {
      Authorization: authToken
    },
    params: {
      pdn
    }
  });
};

export const redeemRewards = (data, authToken) => {
  const config = {
    headers: {
      Authorization: authToken
    }
  };
  return req.post("/loyalty/redeem", data, config);
};

export const redeemRewardsStatusCheck = (pdn, authToken) => {
  const config = {
    headers: {
      Authorization: authToken
    },
    params: {
      pdn
    }
  };
  return req.get("/loyalty/check-redeem-status", config);
};

/**
 * Retrieve a Donor's Advanced Profile Completion Date
 */
export const getDonorApcStatus = (donorSfid, authToken) => {
  const config = {
    headers: {
      Authorization: authToken
    }
  };
  return req.get(`/loyalty/apc-status?donorSfid=${donorSfid}`, config);
};

export const getLoyaltyPromotions = (donorSfid, authToken) => {
  return req.get(`/loyalty/promotions?donorSfid=${donorSfid}`, {
    headers: {
      Authorization: authToken
    }
  });
};

export const activateLoyaltyPromotions = (donorSfid, promotionId, authToken) => {
  const config = {
    headers: {
      Authorization: authToken
    }
  };
  const data = {
    donorSfid,
    promotionId
  };
  return req.patch(`/loyalty/activate-promotion`, data, config);
};

export const getLoyaltyGameData = (donorSfid, authToken) => {
  return req.get(`/loyalty/game-status?donorSfid=${donorSfid}`, {
    headers: {
      Authorization: authToken
    }
  });
};
export const updateLoyaltyGameData = (donorSfid, data, authToken) => {
  const config = {
    headers: {
      Authorization: authToken,
      "Content-Type": "application/json"
    }
  };
  const body = {
    donorSfid: donorSfid,
    data: data
  };
  return req.put(`/loyalty/game-status`, body, config);
};
